import { NavLink } from 'react-router-dom';
import s from './Navigation.module.less';

type OptionType = {
  label: string;
  route: string;
  outsideLink?: boolean;
};
type Props = {
  options: Array<OptionType>;
};

function DropdownMenuItem({ label, route, outsideLink }: OptionType & { key: string }) {
  const LinkComponent = outsideLink ? 'a' : NavLink;
  const linkProps = outsideLink ? { href: route } : { to: route };
  return (
    <li>
      {/* @ts-expect-error */}
      <LinkComponent {...linkProps}>{label}</LinkComponent>
    </li>
  );
}

export default function DropdownMenu({ options }: Props) {
  return (
    <ul className={s.dropdownMenu}>
      {options.map(option => (
        <DropdownMenuItem {...option} key={option.route} />
      ))}
    </ul>
  );
}
